import React from "react";

const Modal = ({ show, onClose, children }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
            <div className="bg-white p-5 rounded-lg shadow-lg" onClick={e => e.stopPropagation()}>
                <div className="flex flex-col p-5 justify-between items-center mb-4">
                <button onClick={onClose} className="text-gray-700 font-bold hover:text-gray-900">❌</button>
                    <h4 className="text-lg font-semibold">✅ Transaction Completed</h4>
                    
                </div>
                <div className="modal-body">
                    {children}
                </div>
                <div className="text-right mt-4">
                    <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 transition duration-300">Close</button>
                </div>
            </div>
        </div>
    );
};


export default Modal;
